import clsx from 'clsx';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { AddRemarkOptionCaptures } from '../form/AddRemarkOptionCaptures';

type Props = {
  data: any;
  show: boolean;
  handleClose: () => void;
  setRemarkOptionCapturesDataMap: React.Dispatch<React.SetStateAction<any>>;
};

const AddRemarkOptionCapturesModal: React.FC<Props> = ({
  data,
  show,
  handleClose,
  setRemarkOptionCapturesDataMap,
}) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDirty, setIsDirty] = useState<boolean>(false);

  return (
    <Modal
      id='add_remark_option_captures_modal'
      tabIndex={-1}
      dialogClassName='modal-dialog-centered mw-1000px h-auto'
      show={show}
    >
      <div className={clsx('container-xxl px-5', isLoading && 'overlay overlay-block')}>
        <div className='modal-body'>
          <div className='overlay-wrapper'>
            {/* Header */}
            <div className='w-100 d-flex justify-content-between mt-5 mb-3'>
              <div>
                <h1 className='d-flex align-items-center text-dark fw-bolder fs-1 ms-md-12'>
                  Add Remark Option Captures{data?.label && ` - ${data.label}`}
                  {isDirty && (
                    <span className='ms-3 badge badge-light-danger align-middle'>
                      Unsaved Changes
                    </span>
                  )}
                </h1>
              </div>
              <div className='btn btn-icon btn-sm btn-light-primary me-md-9' onClick={handleClose}>
                <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
            <AddRemarkOptionCaptures
              data={data}
              onClose={handleClose}
              setRemarkOptionCapturesDataMap={setRemarkOptionCapturesDataMap}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setIsDirty={setIsDirty}
            />
          </div>

          {/* Loading overlay blocker */}
          {isLoading && <div className='overlay-layer bg-white bg-opacity-10 z-index-3'></div>}
        </div>
      </div>
    </Modal>
  );
};
export { AddRemarkOptionCapturesModal };
